import { useCallback, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import useAuth from "utils/customHooks/useAuth";
import { setAppHomeURL } from "utils/store/slice/appState";

const OCMAuthGuard = ({ children }) => {
  const location = useLocation();
  const { getUserLoginState } = useAuth();

  const appStateDispatch = useDispatch();

  const getRedirectPath = useCallback(() => {
    const pathname = location.pathname;
    const search = location.search;
    const hash = location.hash;

    const redirectPath = `${pathname}${search}${hash}`;
    return redirectPath;
  }, [location]);

  const showPage = () => {
    let homeURL = "/offline-contest-management";

    // Set the home URL for OCM
    appStateDispatch(setAppHomeURL(homeURL));

    return children;
  };

  return getUserLoginState() ? (
    showPage()
  ) : (
    <Navigate
      to="/offline-contest-management/login"
      replace
      state={{
        redirectTo: getRedirectPath(),
      }}
    />
  );
};

export default OCMAuthGuard;
